import { render, staticRenderFns } from "./NavBarUserMenu.vue?vue&type=template&id=2c11c772&lang=pug"
import script from "./NavBarUserMenu.vue?vue&type=script&lang=ts"
export * from "./NavBarUserMenu.vue?vue&type=script&lang=ts"
import style0 from "./NavBarUserMenu.vue?vue&type=style&index=0&id=2c11c772&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VAvatar,VDivider,VIcon,VImg,VList,VListItem,VMenu})
